import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = `${process.env.REACT_APP_GLOBO_API}/staticdata/doctors`;
const type = "Doctors";

export const doctorsAPI = createStaticResourceAPI({
  baseURL: `${process.env.REACT_APP_GLOBO_API}/staticdata/doctors`,
  resource: "Doctors",
  idKey: "doctorId",
  tagTypes: ["Globo", "Doctors"],
  lookupMap: (doctor) => ({
    ...doctor,
    value: doctor.doctorId,
    label: doctor.fullName,
    avatarPath: doctor.avatar,
  }),
  customMutations: (mutation, mutationOptions) => ({
    createDoctor: mutation(`${baseURL}/create`, mutationOptions("save")),
    updateDoctor: mutation(`${baseURL}/update`, mutationOptions("save")),
    updateDoctorAvatarPhoto: mutation(`${baseURL}/avatar/update`, mutationOptions("save")),
    doctorExport: mutation(`${baseURL}/export`),
    doctorExportListActive: mutation(`${baseURL}/exportListActive`),
    doctorExportListInActive: mutation(`${baseURL}/exportListInActive`),
  }),
  customQuery: (query, { idKey }) => ({
    getActiveDoctors: query(`${baseURL}/listActive`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success ? [...result?.items?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }] : [{ type: type, id: type }],
    }),
    getInActiveDoctors: query(`${baseURL}/listInActive`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success ? [...result?.items?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }] : [{ type: type, id: type }],
    }),
  }),
});

export const {
  useGetDoctorsQuery,
  useFindDoctorsQuery,
  useLookUpDoctorsMutation,
  useDeleteDoctorsMutation,
  useCreateDoctorMutation,
  useUpdateDoctorMutation,
   useExportDoctorsMutation,
  useUpdateDoctorAvatarPhotoMutation,
  useDoctorExportListActiveMutation,
  useDoctorExportListInActiveMutation,
  useGetActiveDoctorsQuery,
  useGetInActiveDoctorsQuery,
} = doctorsAPI;
